<template>
    <div>
        <div class="bg-white overflow-hidden sm:rounded-md" v-if="showData()">

            <ul role="list" class="divide-y ">


                <li v-for="row in dataRows" :key="row.id">


                    <div href="#" class="block border-2" :class="(searchSelected(row.id)) ? 'isSelected' : 'hover:bg-gray-50 border-transparent rounded-lg'">
                        <div class="px-4 py-4 flex items-center sm:px-6 group relative">

                            <div v-if="buttons && buttons.length > 0"
                                class="absolute hidden right-0 group-hover:flex pr-2 justify-end gap-2">
                                <button v-for="button in buttons" :key="button.name" :class="button.class"
                                    class="flex items-center gap-2" @click="button.action(row)">
                                    <div v-if="button.icon">
                                        <component :is="button.icon" class="h-5 w-5" />
                                    </div>
                                    <div v-if="button.name">
                                        {{ button.name }}
                                    </div>
                                </button>
                            </div>


                            <div v-if=(row.new) class="mr-2">
                                <span
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-cyan-800 text-white">
                                    New
                                </span>
                            </div>

                            <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between cursor-pointer "
                                @click="$emit('open:item', $event, row)">


                                <div class="truncate w-full">

                                    <div class="truncate"
                                        :class="(searchSelected(row.id)) ? 'text-gray-800' : 'text-gray-800'">


                                        <div class="flex items-center">
                                            <div class="w-full">
                                                <div class="font-thin truncate text-[10px]" v-if="row.code">code:
                                                    {{ row.code }}</div>

                                                <div class="font-medium truncate flex items-center">

                                                    <span v-if="row.nivel">{{ nivel(row.nivel) }}</span>

                                                    <div v-if="row.privacy && row.privacy == 'private'">
                                                        <LockClosedIcon class="h-4 pr-1" />
                                                    </div>

                                                    <div v-if="row.color" class="pl-1 pr-2">
                                                        <div class="h-3 w-3 rounded-full ring-2 ring-offset-2 ring-offset-gray-100"
                                                            :class="row.color"></div>
                                                    </div>

                                                    <div v-if="row?.agents?.id"
                                                        class="pr-2 relative p-1.5 shrink-0 flex gap-2">
                                                        <Avatar :avatar="row.agents.avatar" size='xs'
                                                            class="border rounded-full shadow-md" /> ➜
                                                    </div>

                                                    <div class="pr-2 relative p-1.5 shrink-0">
                                                        <Avatar :avatar="row.avatar" size='md'
                                                            class="border rounded-full " />
                                                    </div>

                                                    <div v-if="row.workspaces && row.workspaces.name && !row.type"
                                                        class="pr-1 text-xs">{{ row.workspaces.name }} ➜ </div>

                                                    <div v-if="row.name" class="flex flex-col items-start text-xs">
                                                        {{ row.name }}
                                                        <div v-if="row.status" class="text-xs">
                                                            <div v-if="row.status == 'active'"
                                                                class="text-white bg-lime-600 rounded-full px-2">Ativo
                                                            </div>
                                                            <div v-if="row.status == 'inative'"
                                                                class="text-white bg-rose-600 rounded-full px-2">Inativa
                                                            </div>
                                                        </div>

                                                        <div class="text-xs text-gray-400 flex gap-2">
                                                            <div v-if="row.email">
                                                                {{ row.email }}
                                                            </div>
                                                            <div v-if="row.phone" >
                                                                {{ getPhone(row.phone) }}
                                                            </div>
                                                        </div>

                                                        <div class="text-xs text-gray-600">
                                                             {{ formatDate(row.updated_at) }}
                                                        </div>

                                                        <!-- Tags do contato -->
                                                        <div v-if="row.tags && row.tags.length > 0" class="flex flex-wrap gap-1 mt-1">
                                                            <span v-for="tag in row.tags" :key="tag.id"
                                                                class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium text-white"
                                                                :style="{ backgroundColor: tag.color }">
                                                                {{ tag.name }}
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <div v-if="row.questions">
                                                        <div class="flex gap-2">
                                                            <div class="pt-0.5">
                                                                <QuestionMarkCircleIcon class="h-5 w-5" />
                                                            </div>

                                                            <div>
                                                                <div v-for="(question, index) in row.questions"
                                                                    :key="question.index">
                                                                    <div v-if="index == 0">{{ question.name }}</div>
                                                                </div>
                                                                <div class="flex flex-wrap">
                                                                    <div v-for="(question, index) in row.questions"
                                                                        :key="question.index" class="font-thin">
                                                                        <div v-if="index > 0 && question.name"
                                                                            class="pr-2">{{ question.name }},</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                            <div>
                                                <div v-if="type == 'categories_faq'" class="text-xs">
                                                    {{ total_txt || '' }} {{ row.total }}
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div v-if="row.email && row.type" class="text-sm"
                                        :class="(searchSelected(row.id)) ? 'text-white' : ''">{{ row.email }}</div>

                                    <div v-if="row.attributs" class="">
                                        <div class="text-sm text-gray-500 flex gap-3">
                                            <div v-for="(value, key) in row.attributs" :key="key">
                                                <p class="font-thin text-gray-500 truncate">
                                                    {{ processAttribute(key, value) }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="row.departaments" class="pt-2">

                                        <div class="text-sm text-gray-500  flex flex-wrap gap-1"
                                            v-if="Array.isArray(row.departaments)">

                                            <div v-for="(value, key) in row.departaments" :key="key">
                                                <div :class="(searchSelected(row.id)) ? 'bg-blue-400 text-white' : 'bg-gray-200 text-gray-600'"
                                                    class="flex text-xs p-1 px-2 rounded font-normal truncate">
                                                    ▪ {{ value.name }}
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else class="flex gap-2">
                                            <div class=" text-gray-600 flex text-xs rounded font-normal truncate">
                                                {{ row.workspaces.name }} -> {{ row.departaments.name }}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="mt-4 flex-shrink-0 sm:mt-0 sm:ml-5 flex">
                                    <div v-for="(user, key) in row.users" :key="key">
                                        <Avatar :avatar="user.avatar" size='xs'
                                            class="inline-block rounded-full ring-2 ring-white" />
                                    </div>
                                </div>
                            </div>
                            <div class="ml-5 flex-shrink-0">
                                <ChevronRightIcon class="h-5 w-5 text-green-500" aria-hidden="true" />
                            </div>
                        </div>
                    </div>


                    <div v-if="row.fastcruds" class="px-6 pb-2">
                        <template v-for="crud in row.fastcruds" :key="crud.id">
                            <div class="flex p-2 gap-2 rounded-lg hover:bg-gray-100 cursor-pointer"
                                @click="$emit('open:item_area', $event, crud)">
                                <div>↳</div>
                                <div class="flex flex-col text-sm w-full">
                                    <div>
                                        {{ crud.name }}
                                    </div>

                                    <div class="text-xs">
                                        {{ crud.description }}
                                    </div>

                                </div>
                                <div>
                                    <div class="secondaryButton_sm" @click="">
                                        Editar
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div v-if="row.fastcruds && row.fastcruds.length == 0">
                        <div class="flex flex-col pl-6 text-sm -mt-2 pb-4">
                            <div>
                                Nenhuma área associada
                            </div>
                        </div>
                    </div>


                </li>
            </ul>
        </div>
        <div v-else>
            <noData />
        </div>
    </div>
</template>

<script>

import { ChevronRightIcon, LockClosedIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'

export default {
    name: "ListOptionsUsers",
    props: {
        count: {
            type: Number,
            required: false,
        },
        buttons: {
            type: Array,
            required: false,
        },
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },
        integration: {
            type: Function,
            required: false
        },
        type: {
            type: String,
            required: false
        },
        total_txt: {
            type: String,
            required: false
        },

    },
    emits: ['open:item', 'open:item_area'],

    components: {
        ChevronRightIcon,
        LockClosedIcon,
        QuestionMarkCircleIcon,
    },
    methods: {

        showData() {
            try {
                if (this.dataRows.length) {
                    return true;
                }
                return false
            } catch (e) {
                return false;
            }
        },

        // Verifica se parece com um telefone
        getPhone(phone) {
            if (phone) {
                if (phone.length == 11) {
                    return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
                }
                if (phone.length == 10) {
                    return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
                }
                if (phone.length == 9) {
                    return phone.replace(/(\d{5})(\d{4})/, '$1-$2');
                }
                if (phone.length == 8) {
                    return phone.replace(/(\d{4})(\d{4})/, '$1-$2');
                }
            }
            return phone;
        },


        processAttribute(key, attribute) {
            return this.$Attributs.process(key, attribute);
        },
        searchSelected(id) {
            return this.selected.indexOf(id) > -1;
        },
        nivel(nivel) {
            let seta = '├';
            if (nivel && nivel > 0) {
                for (let i = 1; i <= nivel; i++) {
                    seta = seta + '─';
                }
                seta = seta + '›';
            }
            else {
                seta = '•';
            }
            return seta
        },
        formatDate(date) {
            if (!date) return "N/A";
            const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
            return new Date(date).toLocaleDateString("pt-BR", options);
        },
    },
    created() {

    },

}


</script>

<style scoped>
.isSelected {
    @apply bg-blue-100 text-gray-800 border-2 border-blue-500 rounded-lg;
}
</style>